import React, { useState, useMemo, useEffect, useContext } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import TableAllData from "components/Content/CustomTable/TableAllData";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import AximTooltip from "components/AximTooltip";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Box,
    Snackbar,
    FormControl,
    Alert,
    IconButton
} from "@mui/material";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { apiGet, apiPost, apiDelete } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { Utils } from "common/Utils";
import _ from 'lodash';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import moment from "moment";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationDialog from "components/ConfirmationDialog";
import StatusDetailsDialog from "components/Content/Modal/StatusDetailsDialog";
import dayjs from 'dayjs';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export default function CalendarSettings ({ refresh, isAdmin, isReadonly }) {
    const validationSchema = Yup.object().shape({
        paymentFrequency: Yup.string().required('Pay Frequency is required'),
        startPayDate: Yup.date().default(null)
            .typeError('Invalid start pay date')
            .required('Start pay date is required'),
        endPayDate: Yup.date().default(null)
            .typeError('Invalid end pay date')
            .required('End pay date is required')
            .when("startPayDate",
                (startPayDate, yup) => {
                    if (startPayDate instanceof Date && !isNaN(startPayDate)) {//invalid date
                        return (startPayDate && yup.min(startPayDate, "End Date cannot be before Begin Date"))
                    }
                }),
        workStartDate: Yup.date().default(null)
            .typeError('Invalid work start date')
            .required('Work start date is required'),
        workEndDate: Yup.date().default(null)
            .typeError('Invalid work end date')
            .required('Work end date is required')
            .when("workStartDate",
                (workStartDate, yup) => {
                    if (workStartDate instanceof Date && !isNaN(workStartDate)) {//invalid date
                        return (workStartDate && yup.min(workStartDate, "End Date cannot be before Begin Date"))
                    }
                }),
        benefitDate: Yup.date().default(null)
        .transform(v => {
            console.log('transform benefitDate', v)
            return v;
        })
            .typeError('Invalid benefit date')
            .required('Benefit date is required')
            .test(
                'is-first-day',
                'Please select first day of the month',
                (value, context) => {
                    return value.getDate() == 1;
                },
            ),
        hwBenefitDate: Yup.date().default(null)
            .transform(v => {
                console.log('transform', v)
                return v;
            })
            .typeError('Expected a value of type ${type} but got: ${value}')
            //.typeError('Invalid hw benefit date')
            .required('H&W benefit date is required')
            .test(
                'is-first-day',
                'Please select first day of the month',
                (value, context) => {
                    return value.getDate() == 1;
                },
            )
            .test(
                'compare-benefit-date',
                'HW benefit date must be same as benefit date or 1 month before benefit date',
                (value, context) => {
                    let diff = moment(value).diff(moment(calendar.benefitDate), 'months');
                    return (diff == -1 || diff == 0)
                },
            )
    });
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const newCalendar = {
        "payPeriodID": null,
        "paymentFrequency": null,
        // "dailyFringeCalculation": false,
        "startPayDate": moment().startOf('month').toDate(),
        "endPayDate": moment().startOf('month').add(1, 'years').toDate(),
        "workStartDate": moment().startOf('month').toDate(),
        "workEndDate": moment().endOf('month').toDate(),
        "benefitDate": moment().startOf('month').toDate(),
        "hwBenefitDate": moment().startOf('month').toDate()
    };

    const [calendar, setCalendar] = React.useState(newCalendar)
    const [payFrequencies, setPayFrequencies] = React.useState([])
    const [savingData, setSavingData] = React.useState(false)
    const [checkingData, setCheckingData] = useState(true)
    const [calendarError, setCalendarError] = useState('')
    const [openModal, setOpen] = useState(false)
    const [openEditModal, setOpenEdit] = useState(false)
    const [payPeriodDeleted, setPayPeriodDeleted] = useState(false)

    const [columnsArray, setColumnsArray] = useState([])
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false)
    const [deleting, setDeleting] = useState(false)
    const [confirmMessage, setConfirmMessage] = useState('')
    const [fetchedData, setFetchedData] = useState([])

    const [doShowStatusDetails, setDoShowStatusDetails] = useState(false);
    const [statusTitle, setStatusTitle] = useState("");
    const [statuses, setStatuses] = useState([]);

    const convertToDate = data => {
        if (data != null) {
            return moment(data).toDate()
        }
        return data
    }
    const onSubmit = data => {
        console.log('submit')
        console.dir(data)
        console.dir(calendar)
        calendar.startPayDate = convertToDate(calendar.startPayDate)
        calendar.endPayDate = convertToDate(calendar.endPayDate)
        calendar.workStartDate = convertToDate(calendar.workStartDate)
        calendar.workEndDate = convertToDate(calendar.workEndDate)
        calendar.benefitDate = convertToDate(calendar.benefitDate)
        calendar.hwBenefitDate = convertToDate(calendar.hwBenefitDate)
        if (openEditModal) {
            handleUpdateCalendar()
        }
        else {
            handleSaveCalendar()
        }

    };

    const fetchPayFrequencies = (event) => {
        setCheckingData(true);
        apiGet(apiUrls.getPayFrequencies())
            .then((response) => {
                setPayFrequencies(response.data);
                this.handleCalendarChange('paymentFrequency', response.data[0].payFrequencyID)
            })
            .catch(function (error) {
            })
            .then(function () {
                // always executed
                setCheckingData(false);
            });
    };

    const fetchPayPeriods = (filterStatus) => {
        setCheckingData(true);
        const selectedCompany = localStorage.getItem(`selectedCompanyId`);
        apiGet(apiUrls.getPayPeriods(selectedCompany))
            .then((response) => {
                console.log('fetch pay periods')
                console.dir(response)
                console.dir(filterStatus)
                if (filterStatus === undefined || filterStatus == '') {
                    setFetchedData(response.data);
                }
                else if (filterStatus == 'Close') {
                    setFetchedData(response.data.filter(d => d.statusCode == "CLOSE").sort((a, b) => (a.payDate < b.payDate) ? 1 : ((b.payDate < a.payDate) ? -1 : 0)));
                }
                else {
                    setFetchedData(response.data.filter(d => d.statusCode != "CLOSE").sort((a, b) => (a.payDate > b.payDate) ? 1 : ((b.payDate > a.payDate) ? -1 : 0)));
                }
            })
            .catch(function (error) {
                // console.log("THIS IS ERROR", error);
                setColumnsArray([]);
                setFetchedData([]);
            })
            .then(function () {
                // always executed
                setCheckingData(false);
            });
    };

    const handleEdit = (payPeriod) => {
        setSavingData(false)
        setOpenEdit(true)
        console.log('edit')
        console.log(payPeriod)
        const cal = {
            "payPeriodID": payPeriod.payPeriodID,
            "paymentFrequency": payPeriod.payFrequencyID,
            // "dailyFringeCalculation": false,
            "startPayDate": moment(payPeriod.payDate).toDate(),
            "endPayDate": moment(payPeriod.payDate).toDate(),
            "workStartDate": moment(payPeriod.workStart).toDate(),
            "workEndDate": moment(payPeriod.workEnd).toDate(),
            "benefitDate": moment(payPeriod.benefitDate).toDate(),
            "hwBenefitDate": moment(payPeriod.hwBenefitDate).toDate()
        }
        console.log('cal', cal)
        setCalendar(cal)
        setCalendarError(null)
        reset(cal)
    }


    const handleConfirmDeleteClose = () => {
        console.log('close confirmation')
        setDeleting(false)
        setOpenConfirmDelete(false)
    }

    const handleConfirmDelete = () => {
        console.log('confirm deletion')
        setDeleting(true)
        let companyId = localStorage.getItem(`selectedCompanyId`);
        apiDelete(apiUrls.deletePayPeriod(companyId, calendar.payPeriodID), {})
            .then((response) => {
                console.log('deleted pay period')
                console.dir(response)
                fetchPayPeriods('Not-Close')
                setOpenConfirmDelete(false)
                setPayPeriodDeleted(true)
            })
            .catch(function (error) {
                console.log('error')
                console.dir(error)
            })
            .then(function () {

            });
    }
    const handleDelete = () => {
        setOpenEdit(false)
        console.log(`deleting ${calendar.payPeriodID}`)
        setConfirmMessage(`You are about to delete pay period for ${moment(calendar.workStartDate).format("MM/DD/YYYY")} to ${moment(calendar.workEndDate).format("MM/DD/YYYY")}, are you sure?`)

        setOpenConfirmDelete(true)

    }

    const handleClose = () => {
        setOpen(false)
        setOpenEdit(false)
        //setAnchorEl(null);
    };
    const showAddModal = () => {
        setSavingData(false)
        setCalendar(newCalendar)
        setOpen(true);
        setCalendarError(null)
        //MUST RESET FOR VALIDATION TO WORK
        reset(newCalendar)
        handleCalendarChange('paymentFrequency', payFrequencies[0].payFrequencyID)
    };

    const handleCalendarChange = (propName, propValue) => {
        let obj = { ...calendar }
        obj[propName] = propValue
        if (propValue == '') {
            obj[propName] = null
        }
        if (propName == 'startPayDate') {
            //propValue = moment(propValue).toDate()
            if (calendar.endPayDate < propValue) {
                obj['endPayDate'] = moment(propValue).toDate()
            }
        }

        if (propName == 'benefitDate') {
            if (calendar.hwBenefitDate > propValue) {
                obj['hwBenefitDate'] = moment(propValue).toDate()
            }
        }

        if (propName == 'paymentFrequency' || propName == 'workStartDate') {
            let freuency = (propName == 'paymentFrequency' ? propValue : obj['paymentFrequency'])
            let workStart = calendar.workStartDate

            if (propName == 'paymentFrequency') {
                freuency = propValue
                workStart = calendar.workStartDate
            }
            else {
                freuency = calendar.paymentFrequency
                workStart = propValue
            }

            console.log('freuency')
            console.log(freuency)
            switch (freuency) {
                case 1:
                    //1 monthly
                    obj['workEndDate'] = moment(workStart).endOf('month').toDate()
                    //setValue('workEndDate', moment(calendar.workStartDate).endOf('month').toDate())
                    break;
                case 2:
                    //2 semi-monthly
                    obj['workEndDate'] = moment(workStart).add(14, 'days').toDate()
                    // setValue('workEndDate', moment(calendar.workStartDate).add(15, 'days').toDate())
                    break;
                case 3:
                    //3 weekly
                    obj['workEndDate'] = moment(workStart).add(6, 'days').toDate()
                    //setValue('workEndDate', moment(calendar.workStartDate).add(7, 'days').toDate())
                    break;
                case 4:
                    //4 bi-weekly
                    obj['workEndDate'] = moment(workStart).add(13, 'days').toDate()
                    //setValue('workEndDate', moment(calendar.workStartDate).add(14, 'days').toDate())
                    break;

            }
        }
        setCalendar(obj);

        setValue(propName, propValue, { shouldValidate: true })
        // console.log('new validate')
        // validationSchema.validate(obj).then((x) => {
        //     console.log('valid', x)
        // })
    };

    const handleUpdateCalendar = () => {
        setSavingData(true)
        let companyId = localStorage.getItem(`selectedCompanyId`);
        console.log('updating')
        apiPost(apiUrls.postWorkPayPeriodUpdate(companyId, calendar.payPeriodID),
            {
                PayPeriodID: calendar.payPeriodID,
                PayFrequencyID: calendar.paymentFrequency,
                PayDate: calendar.startPayDate,
                EndPayDate: calendar.endPayDate,
                WorkStart: calendar.workStartDate,
                workEnd: calendar.workEndDate,
                BenefitDate: calendar.benefitDate,
                HWBenefitDate: calendar.hwBenefitDate
            }
        )
            .then((response) => {
                console.log('update calendar')
                console.dir(response)

                setOpenEdit(false)
                setCalendarError(null)
                fetchPayPeriods('Not-Close')

            })
            .catch(function (error) {
                console.log('error')
                console.dir(error)
                if (error?.response?.status == 500) {
                    setCalendarError(error.response?.data)
                }
            })
            .then(function () {
                setSavingData(false)
            });
    };
    const handleSaveCalendar = () => {
        setSavingData(true)
        let companyId = localStorage.getItem(`selectedCompanyId`);
        apiPost(apiUrls.postWorkPayPeriods(companyId),
            {
                PayFrequencyID: calendar.paymentFrequency,
                PayDate: calendar.startPayDate,
                EndPayDate: calendar.endPayDate,
                WorkStart: calendar.workStartDate,
                workEnd: calendar.workEndDate,
                BenefitDate: calendar.benefitDate,
                HWBenefitDate: calendar.hwBenefitDate
            }

        )
            .then((response) => {
                console.log('post calendar')
                console.dir(response)
                setOpen(false)
                setCalendarError(null)
                fetchPayPeriods('Not-Close')

            })
            .catch(function (error) {
                console.log('error')
                console.dir(error)
                if (error?.response?.status == 500) {
                    setCalendarError(error.response?.data)
                }
            })
            .then(function () {
                setSavingData(false)
            });
    };

    useEffect(() => {
        apiGet(apiUrls.getStatuses("PAYPERIOD"))
            .then((response) => {
                setStatuses(response.data);
            })
            .catch(function (e) {
                setStatuses([]);
            });
    }, []);

    useEffect(() => {
        if (refresh > 0) {
            fetchPayPeriods('Not-Close')
        }
        fetchPayFrequencies()

        var actionColumn = 
        {
            Header: "Action",
            accessor: (cell) => (
                <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => handleEdit(cell)}
                >
                    <EditOutlinedIcon />
                </IconButton>)
        };

        if (isReadonly && !isAdmin) {
            setColumnsArray(columns);
        }
        else {
            setColumnsArray([actionColumn, ...columns]);
        }
    },[refresh, isReadonly, isAdmin]);

    useEffect(() => {
        if (refresh > 0) {
            fetchPayPeriods('Not-Close')
        }
        fetchPayFrequencies()
    }, [refresh]);

    let columns = [
        {
            Header: "PayDate",
            accessor: (cell) => Utils.formatDate(cell.payDate),
            Cell: ({ row }) => (
                <Box>
                    {Utils.formatDate(row.original.payDate)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "Work Start",
            accessor: (cell) => Utils.formatDate(cell.workStart),
            Cell: ({ row }) => (
                <Box>
                    {Utils.formatDate(row.original.workStart)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "Work End",
            accessor: (cell) => Utils.formatDate(cell.workEnd),
            Cell: ({ row }) => (
                <Box>
                    {Utils.formatDate(row.original.workEnd)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "Benefit Date",
            accessor: (cell) => Utils.formatDate(cell.benefitDate),
            Cell: ({ row }) => (
                <Box>
                    {Utils.formatDate(row.original.benefitDate)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "HW Benefit Date",
            accessor: (cell) => Utils.formatDate(cell.hwBenefitDate),
            Cell: ({ row }) => (
                <Box>
                    {Utils.formatDate(row.original.hwBenefitDate)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "Tax Period",
            accessor: (cell) => Utils.formatDate(cell.taxPeriod),
            Cell: ({ row }) => (
                <Box>
                    {Utils.formatDate(row.original.taxPeriod)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: () => {
                return (
                    <>
                        Status
                        <IconButton onClick={showStatuses} className="py-0" color="primary"><ListAltOutlinedIcon /></IconButton>
                    </>
                )
            },
            accessor: "statusName"
        }
    ];

    const showStatuses = e => {
        e.stopPropagation();

        setStatusTitle("Calendar Statuses");
        setDoShowStatusDetails(true);
    }
    
    const CalendarDatePicker = (props) => {
        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    views={props.views}
                    {...register(props.fieldName)}
                    id={props.fieldName}
                    name={props.fieldName}
                    minDate={dayjs('01/01/1990')}
                    value={dayjs(calendar[props.fieldName])}
                    onChange={(newValue) => handleCalendarChange(props.fieldName, newValue.toDate())}
                    label={props.label}
                    slotProps={{
                        textField: {
                            helperText: errors[props.fieldName]?.message,
                        },
                    }}
                />
            </LocalizationProvider>
        )
    }

    const ErrorAlert = (props) => {
        if (props.error != null && props.error != '') {
            return (<Alert variant="filled" severity="error">
                {props.error}
            </Alert>)
        }
        return null
    }

    return (
        <>
            {/* Add calendar MODAL */}
            <Dialog
                open={openModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                    Add Pay Periods
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div>
                            <FormControl sx={{ m: 1, minWidth: 200 }}>
                                <InputLabel id="type-of-hour-select-label">Pay Frequency</InputLabel>
                                <Select
                                    {...register('paymentFrequency')}
                                    id="paymentFrequency"
                                    name="paymentFrequency"
                                    label="Payment Frequency"
                                    value={calendar.paymentFrequency ?? ''}
                                    onChange={(e) => handleCalendarChange('paymentFrequency', e.target.value)}
                                    required
                                    variant="standard"
                                    error={errors.paymentFrequency ? true : false}
                                    helperText={errors.paymentFrequency?.message}
                                >
                                    {payFrequencies.map((th, i) => <MenuItem value={th.payFrequencyID} key={i}>{th.payFrequencyName}</MenuItem>)}

                                </Select>
                            </FormControl>

                        </div>
                        <div>
                            <CalendarDatePicker fieldName="startPayDate" label="Start Pay Date" tooltip="Starting Pay date"></CalendarDatePicker>
                            <CalendarDatePicker fieldName="endPayDate" label="End Pay Date" tooltip="Last pay date"></CalendarDatePicker>
                        </div>
                        <div>
                            <CalendarDatePicker fieldName="workStartDate" label="Work Start Date" tooltip="First work start date"></CalendarDatePicker>
                            <CalendarDatePicker fieldName="workEndDate" label="Work End Date" tooltip="First work end date"></CalendarDatePicker>
                        </div>
                        <div>
                            <CalendarDatePicker fieldName="benefitDate" label="Benefit Date" tooltip="Select a benefit month that these hours apply to" views={['month', 'year']}></CalendarDatePicker>
                            <CalendarDatePicker fieldName="hwBenefitDate" label="HW Benefit Date" tooltip="Select a HW benefit month that these hours apply to" views={['month', 'year']} ></CalendarDatePicker>
                        </div>
                        {/* <div>
                            <FormControlLabel control={<Checkbox checked={calendar.dailyFringeCalculation} />}
                                label="Daily Fringe Calculation"
                                onChange={(e) => handleCalendarChange('dailyFringeCalculation', e.target.checked)} />

                        </div> */}
                        <div>
                            <ErrorAlert error={calendarError}></ErrorAlert>
                        </div>
                    </Box>
                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    <Button
                        variant="outlined"
                        onClick={handleSubmit(onSubmit)}
                        disabled={savingData}
                    >
                        {(savingData ? "Saving" : "Save")}
                    </Button>
                    <Button variant="outlined" onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit Payperiod MODAL */}
            <Dialog
                open={openEditModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                    Edit Pay Periods
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div>
                            <CalendarDatePicker fieldName="startPayDate" label="Pay Date" tooltip="Pay date"></CalendarDatePicker>
                        </div>
                        <div>
                            <CalendarDatePicker fieldName="workStartDate" label="Work Start Date" tooltip="First work start date"></CalendarDatePicker>
                            <CalendarDatePicker fieldName="workEndDate" label="Work End Date" tooltip="First work end date"></CalendarDatePicker>
                        </div>
                        <div>
                            <CalendarDatePicker fieldName="benefitDate" label="Benefit Date" tooltip="Select a benefit month that these hours apply to" views={['month', 'year']}></CalendarDatePicker>
                            <CalendarDatePicker fieldName="hwBenefitDate" label="HW Benefit Date" tooltip="Select a HW benefit month that these hours apply to" views={['month', 'year']} ></CalendarDatePicker>
                        </div>
                        <div>
                            <ErrorAlert error={calendarError}></ErrorAlert>
                        </div>
                    </Box>
                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    <Button onClick={handleDelete} variant="outlined" startIcon={<DeleteIcon />} color="error">
                        Delete
                    </Button>
                    <div style={{ flex: '1 0 0' }} />
                    <Button
                        variant="outlined"
                        onClick={handleSubmit(onSubmit)}
                        disabled={savingData}
                    >
                        {(savingData ? "Saving" : "Save")}
                    </Button>
                    <Button variant="outlined" onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <ConfirmationDialog
                TransitionComponent={Transition}
                open={openConfirmDelete}
                onClose={handleConfirmDeleteClose}
                onConfirm={handleConfirmDelete}
                title="Delete pay period"
                message={confirmMessage}
                processing={deleting}
                confirmLabel="OK"
                processingLabel="Deleting"
            />

            <Snackbar
                autoHideDuration={3000}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={payPeriodDeleted}
                onClose={() => setPayPeriodDeleted(false)}
            ><Alert severity="success">Pay period deleted.</Alert>
            </Snackbar>
            <TableAllData
                className={TableStyle.TimeSheetsWrapper}
                columns={columnsArray}
                data={fetchedData}
                isLoading={checkingData}
                headerContents={isReadonly && !isAdmin ? null :
                    <Box sx={{ display: "flex", alignItems: "left" }}>
                        <AximTooltip title="Add Pay Periods" disableFocusListener>
                            <IconButton color="primary" aria-label="Add Pay Periods" component="span"
                                onClick={showAddModal} >
                                <AddCircleOutlineOutlinedIcon />
                            </IconButton>
                        </AximTooltip>
                    </Box>
                }
            />

            <StatusDetailsDialog doShow={doShowStatusDetails} handleClose={() => setDoShowStatusDetails(false)} title={statusTitle} statuses={statuses} />
        </>
    )
}